export default {
    getBpi(state) {
        return { bpi: state.bpi, bpiUid: state.bpiId };
    },
    getUser(state) {
        return state.user;
    },
    getBpiOutPut(state) {
        return state.bpiOutPut;
    },
    getLastStep(state, getters) {
        return step => {
            let steps;
            if (getters.isSimplifiedVersion) {
                steps = [
                    "Profils des investisseurs",
                    "Votre projet",
                    "Taille et évolution du marché",
                    "Analyse Concurrentielle",
                    "Moyens fonciers et immeubles",
                    "Moyens d’exploitation",
                    "Moyens humains",
                    "Programme d’investissement plan de financement",
                    "Chiffres d’affaires Prévisionnels",
                    "Charges Prévisionnels"
                ];
            } else {
                steps = [
                    "Profils des investisseurs",
                    "Votre projet",
                    "Taille et évolution du marché",
                    "Santé financière Des entreprises",
                    "Principaux acteurs et part du marché",
                    "Analyse Concurrentielle",
                    "Moyens Commerciaux",
                    "Moyens fonciers et immeubles",
                    "Moyens d’exploitation",
                    "Moyens humains",
                    "Programme d’investissement plan de financement",
                    "Chiffres d’affaires Prévisionnels",
                    "Achats Prévisionnels",
                    "Autres charges externes",
                    "Charges du personnel"
                ];
            }
            let SavedStepIndex = steps.findIndex(
                item => item === state.bpi.current_step
            );
            let stepIndex = steps.findIndex(item => item === step);

            if (SavedStepIndex > stepIndex) return state.bpi.current_step;
            return step;
        };
    },

    isSettable(state, getters) {
        return step => {
            let steps;

            if (getters.isSimplifiedVersion) {
                steps = [
                    "Profils des investisseurs",
                    "Votre projet",
                    "Taille et évolution du marché",
                    "Analyse Concurrentielle",
                    "Répartition Géographique",
                    "Moyens fonciers et immeubles",
                    "Moyens d’exploitation",
                    "Moyens humains",
                    "Programme d’investissement plan de financement",
                    "Chiffres d’affaires Prévisionnels",
                    "Charges Prévisionnels"
                ];
            } else {
                steps = [
                    "Profils des investisseurs",
                    "Votre projet",
                    "Taille et évolution du marché",
                    "Santé financière Des entreprises",
                    "Principaux acteurs et part du marché",
                    "Analyse Concurrentielle",
                    "Moyens Commerciaux",
                    "Moyens fonciers et immeubles",
                    "Moyens d’exploitation",
                    "Moyens humains",
                    "Programme d’investissement plan de financement",
                    "Chiffres d’affaires Prévisionnels",
                    "Achats Prévisionnels",
                    "Autres charges externes",
                    "Charges du personnel"
                ];
            }

            let SavedStepIndex = steps.findIndex(
                item => item === state.bpi.current_step
            );
            let stepIndex = steps.findIndex(item => item === step);
            return SavedStepIndex >= stepIndex;
        };
    },
    getLastSubStep(state) {
        return subStep => {
            const subSteps = [
                "Votre Entreprise",
                "Votre Projet",
                "Vos Offres",
                "Vos Clients",
                "Installations techniques",
                "Matériels et outillage",
                "Moyens de transports et manutentions",
                "Mobilier et bureaux",
                "Matériel Informatique"
            ];
            if (state.bpi.current_Substep === undefined) return subStep;
            let SavedStepIndex = subSteps.findIndex(
                item => item === state.bpi.current_Substep
            );
            let stepIndex = subSteps.findIndex(item => item === subStep);

            if (SavedStepIndex > stepIndex) return state.bpi.current_Substep;
            return subStep;
        };
    },
    isSimplifiedVersion(state) {
        return state.bpiVersion === "Version Simplifiée";
    }
};
